import { Injectable }       from '@angular/core';


@Injectable()
export class Holidays {
  italianHolidays: any = {
     0: [1, 6],
     1: [],
     2: [],
     3: [25],
     4: [1],
     5: [2],
     6: [],
     7: [15],
     8: [],
     9: [],
    10: [1],
    11: [8, 25, 26]
  }

  constructor() {}

  getHolidays(year: number, month: number): Date[] {
    let holidays: Date[] = [];
    for (var i=0; i<this.italianHolidays[month].length; i++) {
      holidays.push(new Date(year, month, this.italianHolidays[month][i], 12, 0))
    }
    let easter: Date = this.computeEaster(year);
    //console.log("Found easter at: ", easter);
    let mondayEaster: Date = new Date(easter);
    mondayEaster.setDate(easter.getDate()+1);
    //console.log("Found monday-easter at: ", mondayEaster);
    if (easter.getMonth()==month)       holidays.push(easter);
    if (mondayEaster.getMonth()==month) holidays.push(mondayEaster)
    return holidays;
  }

  // https://en.wikipedia.org/wiki/Computus#Algorithms
  computeEaster(year: number): Date {
    let a: number = year % 19;
    let b: number = Math.floor(year/100);
    let c: number = year % 100;
    let d: number = Math.floor(b/4);
    let e: number = b % 4;
    let f: number = Math.floor((b+8) / 25);
    let g: number = Math.floor((b-f+1)/3);
    let h: number = (19*a + b - d - g + 15) % 30;
    let i: number = Math.floor(c/4)
    let k: number = c % 4;
    let l: number = (32 +2*e + 2*i -h -k) % 7;
    let m: number = Math.floor((a + 11*h +22*l)/451);
    let month: number = Math.floor((h+l-7*m+114)/31);
    let day: number = ((h + l -7*m + 114) % 31) + 1;
    return new Date(year, month-1, day, 12, 0);
  }
}



// WEBPACK FOOTER //
// /builds/mediaclinicstn/stampling-viewer/src/providers/Holidays.ts